export class ListWorkspacesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListWorkspacesFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortWorkspaceBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListWorkspacesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
